import { render, staticRenderFns } from "./WhitelabelingPreviewScreen.vue?vue&type=template&id=b0eab192&scoped=true"
import script from "./WhitelabelingPreviewScreen.vue?vue&type=script&lang=js"
export * from "./WhitelabelingPreviewScreen.vue?vue&type=script&lang=js"
import style0 from "./WhitelabelingPreviewScreen.vue?vue&type=style&index=0&id=b0eab192&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0eab192",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0eab192')) {
      api.createRecord('b0eab192', component.options)
    } else {
      api.reload('b0eab192', component.options)
    }
    module.hot.accept("./WhitelabelingPreviewScreen.vue?vue&type=template&id=b0eab192&scoped=true", function () {
      api.rerender('b0eab192', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/WhitelabelingPreviewScreen.vue"
export default component.exports